import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateClientPayload } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { clientSchema } from './schemas';
import { clientsQueryOptions } from './useClients';

export const useUpdateClient = (clientId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateClientPayload) => {
      const { data: client } = await fetchJson(`/clients/${clientId}`, {
        method: 'PATCH',
        schema: apiResourceSchema(clientSchema),
        body,
      });

      return client;
    },
    onSuccess: (updatedClient) => {
      queryClient.setQueryData(clientsQueryOptions.queryKey, (clients) =>
        (clients ?? []).map((client) => (client.id === updatedClient.id ? updatedClient : client)),
      );
      queryClient.invalidateQueries({ queryKey: QueryKeys.clients.index });
    },
  });
};
